import React, { useEffect, useState } from 'react'
import {Toolbar} from '../../layout/Toolbar/Toolbar';
import { CalificacionesFuncionario } from '../../components/Calificaciones/CalificacionesFuncionario';
import { procesosPrecalificador } from '../../utils/Datos';
import { NavLink } from 'react-router-dom';

import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";

export const HistorialPrecalificaciones = () => {

    let toolbarEnlaces = [
        {
          muted: "true",
          to: "/",
          title: "Home",
          bullet: "false",
        },
        {
          muted: "true",
          to: "",
          title: "",
          bullet: "true",
        },
        {
          muted: "false",
          to: null,
          title: "Historial de Precalificaciones",
          bullet: "false",
        },
      ];

    const [procesos, setprocesos] = useState(null);
    const [id_officer, setid_officer] = useState(null);
    const user = useSelector(selectUser);
    

    useEffect(() => {
    //CAMBIAR ID DEL FUNCIONARIO
      procesosPrecalificador(user.user.id_officer).then((datos)=>{
        //console.log('datos',datos);
        
        setprocesos(datos);
      })

      setid_officer(user.user.id_officer);
    }, [user])
    
    
    return (
        <>
        <div
            className="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
            <Toolbar title="Historial de Precalificaciones" enlaces={toolbarEnlaces}></Toolbar>
            <div className="post d-flex flex-column-fluid" id="kt_post">
            <div className="container-xxl">
                <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body vh-75">
                            <div className='row'>
                                <div className='col-md-12'>
                                    {
                                        procesos==null ? 
                                        <div class="alert alert-warning" role="alert">
                                            <strong>No hay procesos asociados a tu usuario</strong>
                                        </div>
                                        :
                                        <table className='table table-rounded table-striped border gy-7 gs-7'>
                                        <thead>
                                            <tr>
                                                <th>Nombre del Proceso</th>
                                              
                                                <th>Año</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
            
                                        <tbody>
                                            {
                                                procesos.map((dato,index)=>{
                                                    return  <tr key={`tr_${index}`}>
                                                               <td>
                                                                    {dato.name}
                                                                </td>
                                                              
                                                                <td>
                                                                    {dato.yearProcess}
                                                                </td>
                                                              
                                                                <td>
                                                                    <NavLink 
                                                                    className="btn btn-primary btn-sm"
                                                                    to={'/precalificacionesPrecalificador/'+dato.id_process+'/'+id_officer}
                                                                    >
                                                                        Ver Precalificaciones
                                                                    </NavLink>
                                                                </td>
                                                            </tr>
                                                })
                                            }
                                            
                                        </tbody>
                                    </table>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </>
    )
}
